// extracted by mini-css-extract-plugin
export default {"container":"delete-modal_container__ObUjo","actions":"delete-modal_actions__YaFWc","exclude":"delete-modal_exclude__3weXg","cancel":"delete-modal_cancel__AoTNe"};